// src/hooks/useReadArticles.ts
import { useEffect, useState } from 'react';
import { getReadArticles, addReadArticle, isArticleRead, clearReadArticles, allReadArticles } from '../Utilis/localStorage'; // Adjust path
import { ReadArticle } from '../types/ReadArticle'; // Adjust path

export function useReadArticles() {
    const [readArticles, setReadArticles] = useState<ReadArticle[]>([]);

    useEffect(() => {
        setReadArticles(getReadArticles());
    }, []);

    const markArticleAsRead = (article: Omit<ReadArticle, 'timestamp'>): void => {
        addReadArticle(article);
        setReadArticles(getReadArticles()); // Refresh state after update
    };

    const checkIfArticleRead = (id: string | number, type: string): boolean => {
        return isArticleRead(id, type);
    };

    const clearAllReadArticles = () => {
        clearReadArticles();
        setReadArticles([]); // Clear state as well
    }

        const getReadArticlesLength = () => {
            return allReadArticles();
    }

    return {
        readArticles,
        markArticleAsRead,
        checkIfArticleRead,
        clearAllReadArticles,
        getReadArticlesLength
    };
}